import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

// item 237 — toggle a customer's favorite pin. Invalidates the CRM list so it re-sorts
// (favorites are ordered first server-side).
const useContactFavorite = () => {
  const queryClient = useQueryClient();
  return useMutation(
    async ({ id, isFavorite }: { id: string; isFavorite: boolean }) => {
      const apiUrl = process.env.REACT_APP_BASIX_API || '';
      await axios.post(`${apiUrl}contacts/${id}/favorite`, { isFavorite });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('contacts'); // CRM list re-sorts
        queryClient.invalidateQueries('contactFavorites'); // sidebar customer pins re-sort
      },
    },
  );
};

export default useContactFavorite;
